import { curry } from 'ramda';

export const categoriesToFilter = categories => categories.toLowerCase().replace('|', ' ');

export const pureTitle = title => title.replace('|', '');

export const findMainImage = curry((project, image) => project.thumb.includes(image.name));

export const filterGallery = curry((project, image) => image.name.includes(project.id));
